import { ThemeUICSSObject, getOneColorState, spacing } from '@apia/theme';

const labelBox: ThemeUICSSObject = {
  alignItems: 'center',
  border: '1px solid',
  borderColor: 'palette.border.field',
  display: 'flex',
  gap: spacing(3),
  justifyContent: 'space-between',
  p: spacing(3),
  pl: spacing(5),

  '&.selected': {
    background: (theme) =>
      getOneColorState('palette.background.paper', 'selected', theme.palette),
  },

  '& > .labelAndIcon': {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(3),

    '& ~ div button': {
      border: 'none',
    },

    svg: {
      minHeight: 'iconMd',
      minWidth: 'iconMd',
    },

    '&:last-of-type': {
      textAlign: 'right',
    },
  },
};

export default labelBox;
